import React from 'react';
import Button from './Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/StarRatingModal.css';
import RespModal from './RespModal';

function StarRatingModal(props) {
    return (
        <RespModal hasOpen={props.hasOpen}>
            <div className="StarRatingModalOuterDivCss" >
                <div id="StarRatingModalContainerDivCss"> 
                    {props.children}
                </div>
                <div class="StarRatingModalButtonDivCss">
                    <Button
                        id="StarRatingModalButtonCss"
                        type="button"
                        class="btn btn-dark"
                        onClick={props.onCloseModal}
                    >Submit
                 </Button>
                </div>
            </div>
        </RespModal>
    );
}
export default StarRatingModal;